<template>
  <q-form @submit="onSubmit" ref="myForm" class="flexbox">
    <div class="q-pa-xs">
      <div class="row q-col-gutter-xs">
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Company Name*</span>
          <q-select
            outlined
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            disable
            :option-label="company => company.name"
            :option-value="company => company.id"
            :rules="[val => (val !== null && val !== '') || 'Please type your company name']"
            v-model="selectedCompany"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
            </template>
          </q-select>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Location Name*</span>
          <q-input
            outlined
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            :rules="[val => (val !== null && val !== '') || 'Please type your location name']"
            v-model="name"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">State*</span>
          <q-select
            class="customTextColor"
            outlined
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            :options="countries"
            :placeholder="placeholderGenerator(state, 'Select State')"
            :rules="[val => !!val || 'Please select your state']"
            map-options
            emit-value
            use-input
            @filter="filterCountries"
            option-label="name"
            option-value="id"
            v-model="state"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-flag" size="16px" color="grey-7"></q-icon>
            </template>
          </q-select>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">City*</span>
          <q-select
            class="customTextColor"
            :disable="loadingCities"
            outlined
            ref="city"
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            :rules="[val => !!val || 'Please select your city']"
            :loading="loadingCities"
            @filter="filterCities"
            :placeholder="placeholderGenerator(city, 'Select City')"
            :options="cities"
            option-label="name"
            option-value="id"
            v-model="city"
            map-options
            emit-value
            use-input
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-city" size="16px" color="grey-7"></q-icon>
            </template>
          </q-select>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Region*</span>
          <q-select
            class="customTextColor"
            outlined
            ref="region"
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            :rules="[val => !!val || 'Please select your region']"
            :placeholder="placeholderGenerator(region, 'Select Region', (key = 'code'))"
            :options="regions"
            option-label="name"
            option-value="code"
            v-model="region"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-city" size="16px" color="grey-7"></q-icon>
            </template>
          </q-select>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">ZIP Code*</span>
          <q-input
            outlined
            type="number"
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            :rules="[val => (val !== null && val !== '') || 'Please type zip code']"
            v-model="zip"
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-at" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Code*</span>
          <q-input outlined color="grey-7" label-color="grey-7" v-model="code"></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Address*</span>
          <q-input
            class="customTextColor"
            outlined
            lazy-rules
            v-model="address"
            color="grey-7"
            label-color="grey-7"
            :rules="[val => (val !== null && val !== '') || 'Please type your address']"
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-map-marker-alt" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Phone Number</span>
          <q-input outlined color="grey-7" mask="(###)-###-####" label-color="grey-7" v-model="phone">
            <template v-slot:prepend>
              <q-icon name="fas fa-phone" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Person</span>
          <q-input outlined color="grey-7" label-color="grey-7" v-model="person">
            <template v-slot:prepend> <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon> </template
          ></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Email</span>
          <q-input outlined color="grey-7" label-color="grey-7" v-model="email" :rules="[isValidEmail]">
            <template v-slot:prepend>
              <q-icon name="fas fa-envelope" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Monthly Depreciation Assumption*</span>
          <q-input
            outlined
            hide-bottom-space
            type="number"
            step="0.1"
            color="grey-7"
            label-color="grey-7"
            prefix="%"
            :rules="[
              val =>
                val == null ||
                val == '' ||
                (val > 0 && val < 100) ||
                'Monthly depreciation assumption must bigger than 0 and less than 100'
            ]"
            v-model="monthly_depreciation_assumption"
          ></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Monthly Mileage Assumption*</span>
          <q-input
            outlined
            hide-bottom-space
            type="number"
            label-color="grey-7"
            color="grey-7"
            :rules="[val => val == null || val == '' || val > 0 || 'Monthly mileage assumption must bigger than 0']"
            v-model="monthly_mileage_assumption"
          ></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Finance Length*</span>
          <q-input
            outlined
            hide-bottom-space
            type="number"
            label-color="grey-7"
            color="grey-7"
            :rules="[val => val == null || val === '' || val > 0 || 'Finance length must bigger than 0']"
            v-model="finance_length"
          ></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Due Location Name</span>
          <q-input
            outlined
            hide-bottom-space
            color="grey-7"
            label-color="grey-7"
            v-model="due_location_name"
          ></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Pickup Location Number</span>
          <q-input
            outlined
            hide-bottom-space
            color="grey-7"
            label-color="grey-7"
            layz-rules
            v-model="pickup_location_number"
          ></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">AVG CR</span>
          <q-input
            outlined
            hide-bottom-space
            type="number"
            step="0.1"
            color="grey-7"
            label-color="grey-7"
            layz-rules
            :rules="[
              val => (val >= 0 && val <= 5) || 'Must bigger than 0 and less than 5'
            ]"
            v-model="avg_cr"
          ></q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6"></div>
        <div class="mt-5 flex-start q-gutter-xs" style="margin-top:10px">
          <q-btn style="margin-right:10px" @click="isAddCompany = false" color="grey-7" label="Close"></q-btn>
          <q-btn :loading="loading" label="Save" type="submit" color="positive">
            <template v-slot:loading>
              <q-spinner-facebook />
            </template>
          </q-btn>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import axios from '../axios/index'
export default {
  data() {
    return {
      person: '',
      email: '',
      phone: '',
      monthly_depreciation_assumption: null,
      monthly_mileage_assumption: null,
      zip: '',
      loadingCities: false,
      loading: false,
      address: '',
      code: '',
      city: null,
      state: null,
      name: '',
      region: null,
      finance_length: null,
      pickup_location_number: null,
      due_location_name: null,
      avg_cr: null,
      regions: [],
      states: [],
      cityByState: [],
      cities: [],
      countries: []
    }
  },
  mounted() {
    this.getStates()
    this.getRegions()
  },
  methods: {
    async getRegions() {
      try {
        const {
          data: { data }
        } = await axios.get('regions')
        this.regions = data
      } catch (error) {}
    },
    placeholderGenerator(val, text, key = 'id') {
      const typeOfValue = typeof val
      if (typeOfValue === 'string') {
        return val ? '' : text
      } else if (typeOfValue === 'object') {
        return val?.[key] ? '' : text
      }
    },
    filterCountries(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.countries = this.states.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterCities(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.cities = this.cityByState.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    isValidEmail(val) {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/
      if (val) return emailPattern.test(val) || 'Invalid email'
    },
    reset() {
      this.city = null
      this.name = ''
      this.state = null
      this.code = ''
      this.address = ''
      this.zip = ''
      ;(this.person = ''), (this.email = '')
      this.phone = ''
      this.region = null
      this.finance_length = null
      ;(this.monthly_depreciation_assumption = null),
        (this.monthly_mileage_assumption = null),
      this.pickup_location_number = null
      this.due_location_name = null
      this.avg_cr = null
    },
    async getCities(id) {
      try {
        const { data } = await axios.get(`cities/${id}`)
        this.cities = data.data
        this.cityByState = data.data
      } catch (error) {
      } finally {
      }
    },
    async getStates() {
      try {
        this.loadingCities = true
        const { data } = await axios.get('states')
        this.states = data.data
        this.countries = data.data
      } catch (error) {
      } finally {
        this.loadingCities = false
      }
    },
    async onSubmit() {
      try {
        this.loading = true
        const body = {
          state: typeof this.state === 'string' ? this.state : this.state.id,
          city: typeof this.city === 'string' ? this.city : this.city.id,
          name: this.name,
          address: this.address,
          zip: this.zip,
          company: this.selectedCompany.id,
          finance_length: Number(this.finance_length),
          region: this.region.code,
          pickup_location_number: this.pickup_location_number !== '' ? this.pickup_location_number : null,
          due_location_name: this.due_location_name !== '' ? this.due_location_name : null,
          avg_cr: this.avg_cr !== '' ? this.avg_cr : null
        }
        if (this.code) body.code = this.code
        if (this.phone)
          body.phone = this.phone
            .split('(')
            .join('')
            .split(')')
            .join('')
            .split('-')
            .join('')
        if (this.monthly_mileage_assumption) body.monthly_mileage_assumption = Number(this.monthly_mileage_assumption)
        if (this.monthly_depreciation_assumption)
          body.monthly_depreciation_assumption = Number(this.monthly_depreciation_assumption)
        if (this.email) body.email = this.email
        if (this.person) body.person = this.person
        const { data } = await axios.put('locations', body)
        this.$store.commit('location/ADD_LOCATION', data.data)
        this.$store.commit('vehicle/ADD_LOCATION_TO_SELECTED_LOCATION', data.data)
        this.$store.commit('profit/ADD_LOCATION_TO_SELECTED_LOCATION', data.data)
        this.reset()
        this.$refs.myForm.resetValidation()
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (error) {
        const errors = error.response?.data?.errors || 'Something went wrong'
        let message = ''
        function errorHandler(obj) {
          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const element = obj[key]
              if (Array.isArray(element)) {
                message = element[0]
              } else if (typeof element === 'object') {
                errorHandler(element)
              } else {
                message = element
              }
            }
          }
        }
        if (error.response?.data?.code === 404) {
          message = error.response?.data?.message
        } else if (error.response?.data?.code === 422) {
          errorHandler(errors)
        }

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    isAddCompany: {
      get() {
        return this.$store.state.company.isAddCompany
      },
      set(val) {
        this.$store.commit('company/SET_IS_ADD_COMPANY', val)
      }
    },
    add: {
      get() {
        return this.$store.state.location.add
      },
      set(val) {
        this.$store.commit('location/SET_ADD', val)
      }
    },
    selectedCompany() {
      return this.$store.state.location.selectedCompany
    }
  },
  watch: {
    add(n, o) {
      if (!n) this.reset()
    },
    state: {
      deep: true,
      handler(n, o) {
        if (n) {
          this.getCities(n)
          if (this.$store.state.profile.user.state.id !== n) {
            this.city = null
            this.getStates()
          }
          this.$refs.city.resetValidation()
        } else {
          this.getStates()
          this.cities = []
          this.city = null
        }
      }
    }
  }
}
</script>
